import Rollbar from 'rollbar';

export default new Rollbar({
    accessToken: 'bbf3f59a8bee4beb9900721183a36e5f',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: 'app-development'
})
